import { useEffect, useState } from "react"

// Module-level cache so navigating between SPA routes doesn't re-fetch
// /api/v1/me every time. Cleared on full page reload (browser leaves the SPA).
let cached = null
let cachedPromise = null

export default function useUser() {
  const [state, setState] = useState(() => {
    if (cached) return { status: "ready", user: cached }
    return { status: "loading", user: null }
  })

  useEffect(() => {
    if (cached) return
    if (!cachedPromise) {
      cachedPromise = fetch("/api/v1/me", {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
        .then((r) => {
          if (r.status === 200) return r.json()
          if (r.status === 401) return null
          throw new Error("Failed to fetch user")
        })
        .then((user) => {
          cached = user
          return user
        })
        .catch(() => {
          // Clear the in-flight promise so a transient network error doesn't
          // permanently mark the user as anonymous — the next mount retries.
          cachedPromise = null
          return null
        })
    }
    cachedPromise.then((user) =>
      setState({ status: user ? "ready" : "anonymous", user })
    )
  }, [])

  return state
}
